import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = ({ testimonial, type = "beneficiary" }) => {
  const typeConfig = {
    beneficiary: {
      bgColor: "bg-gradient-to-br from-emerald-50 to-emerald-100",
      iconColor: "text-emerald-600",
      icon: "Heart"
    },
    partner: {
      bgColor: "bg-gradient-to-br from-blue-50 to-blue-100", 
      iconColor: "text-blue-600",
      icon: "Handshake"
    },
    member: {
      bgColor: "bg-gradient-to-br from-purple-50 to-purple-100",
      iconColor: "text-purple-600", 
      icon: "Star"
    }
  };

  const config = typeConfig[type];

  return (
    <div className="bg-card rounded-xl p-6 card-shadow hover:card-shadow-hover transition-smooth">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative">
          <Image
            src={testimonial.avatar}
            alt={testimonial.name}
            className="w-16 h-16 rounded-full object-cover"
          />
          <div className={`absolute -bottom-1 -right-1 w-6 h-6 ${config.bgColor} rounded-full flex items-center justify-center`}>
            <Icon name={config.icon} size={14} className={config.iconColor} />
          </div>
        </div>
        
        <div className="flex-1">
          <h4 className="font-semibold text-foreground">{testimonial.name}</h4>
          <p className="text-sm text-muted-foreground">{testimonial.role}</p>
          {testimonial.organization && (
            <p className="text-xs text-muted-foreground">{testimonial.organization}</p>
          )}
        </div>

        <div className="flex items-center space-x-1">
          {[...Array(5)].map((_, i) => (
            <Icon
              key={i}
              name="Star"
              size={16}
              className={i < testimonial.rating ? "text-amber-400 fill-current" : "text-gray-300"}
            />
          ))}
        </div>
      </div>

      <blockquote className="text-muted-foreground italic mb-4 leading-relaxed">
        "{testimonial.content}"
      </blockquote>

      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{testimonial.project}</span>
        <span>{testimonial.date}</span>
      </div>
    </div>
  );
};

export default TestimonialCard;